import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FinalizeSubscriptionComponent } from './finalize-subscription/finalize-subscription.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { SubscriptionRoutingModule } from './subscription-routing.module';

@NgModule({
  declarations: [FinalizeSubscriptionComponent],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    SharedModule,
    SubscriptionRoutingModule
  ]
})
export class SubscriptionModule { }
